import React, { useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

const Residential = () => {
  const [tab, setTab] = useState("buy");
  const [form, setForm] = useState({ name: "", email: "", phone: "", address: "", bedrooms: "", bathrooms: "", notes: "", property_type: "residential" });
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/public/valuation", { ...form, bedrooms: Number(form.bedrooms || 0), bathrooms: Number(form.bathrooms || 0) });
      setMsg("Thank you. Your complimentary valuation report will arrive within 2 business days.");
      setForm({ name: "", email: "", phone: "", address: "", bedrooms: "", bathrooms: "", notes: "", property_type: "residential" });
    } catch { setMsg("Please try again."); }
  };

  return (
    <div data-testid="residential-page">
      <section className="bg-navy text-white py-24 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1706808849827-7366c098b317?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">Residential</div>
          <h1 className="font-display text-4xl lg:text-6xl mt-4 max-w-3xl">Homes, estates, and generational residences.</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          <button onClick={() => setTab("buy")} className={`p-8 border text-left transition ${tab === "buy" ? "border-gold bg-slate-50" : "border-slate-200 hover:border-navy"}`} data-testid="res-tab-buy">
            <div className="font-display text-2xl text-navy">Buy a Home</div>
            <p className="text-sm text-slate-600 mt-2">Discreet search representation and off-market access.</p>
          </button>
          <button onClick={() => setTab("sell")} className={`p-8 border text-left transition ${tab === "sell" ? "border-gold bg-slate-50" : "border-slate-200 hover:border-navy"}`} data-testid="res-tab-sell">
            <div className="font-display text-2xl text-navy">Sell a Home</div>
            <p className="text-sm text-slate-600 mt-2">Premium marketing, global buyer network, pricing strategy.</p>
          </button>
          <button onClick={() => setTab("value")} className={`p-8 border text-left transition ${tab === "value" ? "border-gold bg-slate-50" : "border-slate-200 hover:border-navy"}`} data-testid="res-tab-value">
            <div className="font-display text-2xl text-navy">Home Valuation</div>
            <p className="text-sm text-slate-600 mt-2">Complimentary private valuation within 48 hours.</p>
          </button>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-12">
          <div>
            <div className="overline text-gold">{tab === "buy" ? "Buy" : tab === "sell" ? "Sell" : "Valuation"}</div>
            <h2 className="font-display text-3xl text-navy mt-3">
              {tab === "buy" && "Let us find the home others can't."}
              {tab === "sell" && "List with conviction, sell with discretion."}
              {tab === "value" && "Know your home's true market position."}
            </h2>
            <p className="mt-6 text-slate-700 leading-relaxed">
              {tab === "buy" && "Our advisors source off-market and pre-market trophy homes for discerning buyers. Every engagement begins with an exploratory, no-obligation conversation."}
              {tab === "sell" && "From pricing through close, a senior broker owns your sale. Our global buyer network and editorial-grade marketing routinely produce record-setting results."}
              {tab === "value" && "Submit the form for a complimentary, confidential valuation report — combining local comps, off-market activity, and our proprietary price intelligence."}
            </p>
            <div className="mt-8">
              <Link to="/listings?category=residential" className="btn-navy" data-testid="res-view-listings">View Residential Listings</Link>
            </div>
          </div>

          <form onSubmit={submit} className="bg-slate-50 border border-slate-200 p-8 space-y-4" data-testid="valuation-form">
            <div className="overline text-gold">Free valuation · 48h turnaround</div>
            <h3 className="font-display text-2xl text-navy">Tell us about your home</h3>
            <div className="grid grid-cols-2 gap-3">
              <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-name" />
              <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-email" />
            </div>
            <input placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-phone" />
            <input required placeholder="Property address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-address" />
            <div className="grid grid-cols-2 gap-3">
              <input type="number" placeholder="Bedrooms" value={form.bedrooms} onChange={(e) => setForm({ ...form, bedrooms: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-beds" />
              <input type="number" placeholder="Bathrooms" value={form.bathrooms} onChange={(e) => setForm({ ...form, bathrooms: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-baths" />
            </div>
            <textarea rows="3" placeholder="Notes (optional)" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="val-notes" />
            <button className="btn-navy w-full" data-testid="val-submit">Request Valuation</button>
            {msg && <div className="text-sm text-navy" data-testid="val-status">{msg}</div>}
          </form>
        </div>
      </section>
    </div>
  );
};

export default Residential;
